import { Card, Grid, IconButton } from '@mui/material'
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { useAppContext } from '../../../libs/app-core/AppContext'
import { Toast } from '../../../libs/app-core/Toast'
import { useGridApiRef } from '../../../libs/data-grid-view/useGridApiRef'
import { linear_item, linear_v } from '../../../libs/linear-layout/LinearLayout'
import UcDgvCustomPagination from '../../components/UcDgvCustomPagination'
import { DGV_LOCAL_TEXT } from '../../components/UIHelper'
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { UniAnswer } from '../../dao/UniAnswer'
import Title from '../../../libs/rhf-mui/ui/Title'
import { new_ErrorAlert } from '../../export_spwk/ExportManager'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import HelpIcon from '@mui/icons-material/Help';
import { FinishStatus, SpwkToHisInfo } from './SpwkToHisInfo'
import { MessageDialog } from '../../../libs/app-core/dialogs/MessageDialog'
import { DialogButtons } from '../../../libs/app-core/dialogs/DialogButtons'
import dayjs from 'dayjs'


type Props = {
  AnsList: UniAnswer[];
  SelectedAnswerGuid: string;
  OnAnswerSelected: (answer_guid: string) => void;

  InfoList: SpwkToHisInfo[];
}

const UcAnsList = ({ AnsList, SelectedAnswerGuid, OnAnswerSelected,
  InfoList, ...props }: Props) => {

  const ctx = useAppContext();


  const columns: GridColDef[] = [
    {
      field: 'ExportBundle_FinishStatus', headerName: '中繼', width: 72,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        let find = InfoList.find(x => x.ANSWER_GUID === ans.guid);
        return find?.get_ExportBundle_FinishStatus() ?? FinishStatus.Unknown;
      },
      renderCell: (params: GridRenderCellParams<FinishStatus>) => {
        const value: FinishStatus = params.value ?? FinishStatus.Unknown;
        const ans: UniAnswer = params.row;
        return (<>
          <IconButton aria-label="delete" size="small"
            onClick={() => { ShowExportBundleErrors(ans) }}>
            {render_StatusIcon(value)}
          </IconButton>
        </>);
      }
    },
    {
      field: 'HisDto_FinishStatus', headerName: '院內', width: 72,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        let find = InfoList.find(x => x.ANSWER_GUID === ans.guid);
        return find?.get_HisDto_FinishStatus() ?? FinishStatus.Unknown;
      },
      renderCell: (params: GridRenderCellParams<FinishStatus>) => {
        const value: FinishStatus = params.value ?? FinishStatus.Unknown;
        const ans: UniAnswer = params.row;
        return (<>
          <IconButton aria-label="delete" size="small"
            onClick={() => { ShowHisDtoErrors(ans) }}>
            {render_StatusIcon(value)}
          </IconButton>
        </>);
      }
    },
    {
      field: 'his', headerName: 'his匯入', width: 64,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.IsHisUploadDone()) {
          return true;
        } else if (!ans.IsHisUploadDone()) {
          return false;
        } else {
          throw new_ErrorAlert('7494521  未知的錯誤');
        }
      },
      renderCell: (params: GridRenderCellParams<boolean>) => {
        const value = params.value
        if (value == null) {
          throw new_ErrorAlert('4697315')
        }
        return render_DoneIcon(value)
      }
    },
    {
      field: 'gov', headerName: 'gov匯入', width: 64,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.IsGovUploadDone()) {
          return true;
        } else if (!ans.IsGovUploadDone()) {
          return false;
        } else {
          throw new_ErrorAlert('7461321 未知的錯誤');
        }
      },
      renderCell: (params: GridRenderCellParams<boolean>) => {
        const value = params.value
        if (value == null) {
          throw new_ErrorAlert('4684125')
        }
        return render_DoneIcon(value)
      }
    }, {
      field: 'ui', headerName: 'ui匯入', width: 64,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.IsUiUploadDone()) {
          return true;
        } else if (!ans.IsUiUploadDone()) {
          return false;
        } else {
          throw new_ErrorAlert('7451321 未知的錯誤');
        }
      },
      renderCell: (params: GridRenderCellParams<boolean>) => {
        const value = params.value
        if (value == null) {
          throw new_ErrorAlert('4684125')
        }
        return render_DoneIcon(value)
      }
    },
    { field: 'member_code', headerName: '編號', width: 120 },
    { field: 'member_name', headerName: '名稱', width: 120 },
    {
      field: 'his_upload_dt', headerName: 'his匯入時間', width: 120,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (dayjs(ans.his_upload_dt).year() !== 2999) {
          return ans.his_upload_dt
        } else if (dayjs(ans.his_upload_dt).year() === 2999) {
          return '尚未匯入'
        } else {
          throw new_ErrorAlert("455676318,未知的錯誤");
        }
      }
    },
    {
      field: 'gov_upload_dt', headerName: 'gov匯入時間', width: 120,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (dayjs(ans.gov_upload_dt).year() !== 2999) {
          return ans.gov_upload_dt
        } else if (dayjs(ans.gov_upload_dt).year() === 2999) {
          return '尚未匯入'
        } else {
          throw new_ErrorAlert("455676318,未知的錯誤");
        }
      }
    },
    {
      field: 'ui_upload_dt', headerName: 'ui匯入時間', width: 120,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (dayjs(ans.ui_upload_dt).year() !== 2999) {
          return ans.ui_upload_dt
        } else if (dayjs(ans.ui_upload_dt).year() === 2999) {
          return '尚未匯入'
        } else {
          throw new_ErrorAlert("455676318,未知的錯誤");
        }
      }
    },
    {
      field: 'his_upload_err_msg', headerName: 'his匯入錯誤訊息', width: 120,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.his_upload_err_msg === '') {
          return '無'
        } else if (ans.his_upload_err_msg === null || ans.his_upload_err_msg === undefined) {
          throw new_ErrorAlert('4479114 未知的錯誤')
        } else {
          return ans.his_upload_err_msg
        }
      }
    },
    {
      field: 'gov_upload_err_msg', headerName: 'gov匯入錯誤訊息', width: 120,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.gov_upload_err_msg === '') {
          return '無'
        } else if (ans.gov_upload_err_msg === null || ans.gov_upload_err_msg === undefined) {
          throw new_ErrorAlert('4479114 未知的錯誤')
        } else {
          return ans.gov_upload_err_msg
        }
      }
    },
    {
      field: 'ui_upload_err_msg', headerName: 'ui匯入錯誤訊息', width: 120,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.ui_upload_err_msg === '') {
          return '無'
        } else if (ans.ui_upload_err_msg === null || ans.ui_upload_err_msg === undefined) {
          throw new_ErrorAlert('4479114 未知的錯誤')
        } else {
          return ans.ui_upload_err_msg
        }
      }
    },



  ]

  function ShowExportBundleErrors(ans: UniAnswer) {

    let info = InfoList.find(x => x.ANSWER_GUID === ans.guid);

    if (info == null) {
      Toast.ShowWarning(ctx, "缺少 info !?");
      return;
    }

    let message = info.get_ExportBundle_ErrorWarningMessage();

    MessageDialog.Show(ctx, message, `中繼檔訊息 [${ans.member_code}] ${ans.member_name}`,
      { ...DialogButtons.OK }
    );

  }

  function ShowHisDtoErrors(ans: UniAnswer) {

    let info = InfoList.find(x => x.ANSWER_GUID === ans.guid);

    if (info == null) {
      Toast.ShowWarning(ctx, "缺少 info !?");
      return;
    }

    let message = info.get_HisDto_ErrorWarningMessage();

    MessageDialog.Show(ctx, message, `中繼檔訊息 [${ans.member_code}] ${ans.member_name}`,
      { ...DialogButtons.OK }
    );

  }


  const grid_api = useGridApiRef(columns);



  return (
    <Grid {...linear_v}>
      <Grid {...linear_item} height={128} padding={2} sx={{ bgcolor: '#D9DCE0' }}>
        <Grid item><Title variant='body2'>[UcAnsList]</Title> </Grid>
        <Grid item>
          <Title variant='caption'>AnsList: x{AnsList.length}</Title> &nbsp;
          <Title variant='caption'>InfoList: x{InfoList.length}</Title>
        </Grid>
        <Grid item><Title variant='caption'>ans_guid: {SelectedAnswerGuid}</Title> </Grid>
      </Grid>
      <Grid {...linear_item} flex={1}>
        {render_DataGrid()}
      </Grid>
    </Grid>
    // </Box>
  )



  function render_DataGrid() {

    return (

      <Card sx={{ height: '100%', width: '100%' }}>
        <DataGrid sx={{ width: '100%', background: '#F7FBFF', padding: '2px', border: 'none' }}
          columns={grid_api.columns}
          rows={AnsList}

          getRowId={(data) => { return data.guid }}

          pageSize={100}
          rowsPerPageOptions={[100]}

          components={{
            Pagination: () => {
              return <UcDgvCustomPagination />
            },
          }}

          localeText={DGV_LOCAL_TEXT}// 中文
          onRowDoubleClick={(params) => {
            Toast.Show(ctx, "個案: " + params.id);
          }}


          onSelectionModelChange={(ids) => {
            if (ids.length > 1) {
              throw new_ErrorAlert("目前僅支援看一筆資料!!!");
            }

            let answer_guid: string = "" + ids[0];
            OnAnswerSelected(answer_guid);

          }}
        />
      </Card>
    );
  }

  function render_StatusIcon(status: FinishStatus) {
    if (status === FinishStatus.Success) {
      return <CheckCircleIcon fontSize="medium" color='success' />;
    } else if (status === FinishStatus.Unknown) {
      return <HelpIcon fontSize="medium" color='inherit' />;
    } else if (status === FinishStatus.Error) {
      return <ErrorIcon fontSize="medium" color='error' />;
    } else if (status === FinishStatus.Warning) {
      return <WarningIcon fontSize="medium" color='warning' />;
    } else {
      throw new_ErrorAlert("41646 未知的 Status !!!");
    }
  }
  function render_DoneIcon(status: boolean) {
    if (status === true) {
      return (<IconButton size="small" edge="start" color="success" aria-label="menu" sx={{ mr: 2 }}            >
        <CheckCircleIcon />
      </IconButton>);
    } else if (status === false) {
      return (<IconButton size="small" edge="start" aria-label="menu"
        sx={{ mr: 2, color: "#DDDDDD" }}>
        <IndeterminateCheckBoxIcon />
      </IconButton>);
    } else {
      throw new_ErrorAlert('9713642')
    }
  }

}

export default UcAnsList